import { axInst } from "../../Components/Login/Service.jsx";

//region
export const fetchRegion = async () => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  });
  const regionsArray = data?.REGION.buckets.map((e) => e.key);
  const sortedRegionArray = regionsArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedRegionArray;
};

//state
export const fetchStates = async (pRegion) => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: pRegion || [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  });
  const statesArray = data?.STATE.buckets.map((e) => e.key);
  const sortedStatesArray = statesArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesArray;
};

//stateoffice
export const fetchStatesOffice = async (pRegion, pState) => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  });
  const statesOfficeArray = data?.STATE_OFFICE.buckets.map((e) => e.key);
  const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesOfficeArray;
};

//DealerName
export const fetchDealer = async (pRegion, pState, pStateOffice) => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  });
  const DealerArray = data?.DEALER_NAME.buckets.map((e) => e.key);
  const sortedDealerArray = DealerArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedDealerArray;
};

//DealerCode
export const fetchDealercode = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer
) => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  });
  const dealercodeArray = data?.DEALER_CODE.buckets.map((e) => e.key);
  const sorteddealercodeArray = dealercodeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sorteddealercodeArray;
};

//ProductLine
export const fetchProductLine = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode
) => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  });
  const productLineArray = data?.Product_Line.buckets.map((e) => e.key);
  const sortedProductLineArray = productLineArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedProductLineArray;
};

//Lob
export const fetchLOB = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine
) => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: [],
    ppl: [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  });

  const lobArray = data?.LOB.buckets.map((e) => e.key);
  const sortedLobArray = lobArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedLobArray;
};

//ppl
export const fetchPPL = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob
) => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  });
  const pplArray = data?.PPL.buckets.map((e) => e.key);
  const sortedPPLArray = pplArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedPPLArray;
};

//pl
export const fetchPL = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob,
  pPpl
) => {
  const { data } = await axInst.post("realization/realization_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  });
  const plArray = data?.PL.buckets.map((e) => e.key);
  const sortedPLArray = plArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedPLArray;
};

export const fetchTsm = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob,
  pPpl,
  pPl
) => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: pPl || [],
    Tsm_Name: [],
    Spm_Name: [],
  });

  const tsmArray = data?.TSM_NAMES.buckets.map((e) => e.key);
  const sortedtsmArray = tsmArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedtsmArray;
};

export const fetchSpm = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob,
  pPpl,
  pPl,
  pTsmName
) => {
  const { data } = await axInst.post("/realization/realization_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: pPl || [],
    Tsm_Name: pTsmName || [],
    Spm_Name: [],
  });

  const spmArray = data?.SPM_NAMES.buckets.map((e) => e.key);
  const sortedspmArray = spmArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedspmArray;
};
